<script setup>
import { icons, sortCats } from "lib/modules/cat";
import { sortByKey } from "lib/modules/util";
import { catNames } from "db";
import Card from "lib/srv/components/Card";
import { addSrvsSchema } from "lib/modules/schema";

const props = defineProps(["srvs", "ccy"]);

let pcats = {};

for (const srv of props.srvs) {
	if (!(srv.pcat_id in pcats))
		pcats[srv.pcat_id] = null;
}

pcats = Object.keys(pcats).map((pcat_id) => {
	return { pcat_id, name: catNames[pcat_id] };
});

sortCats(pcats, "pcat_id");
sortByKey(props.srvs, "^publish");
addSrvsSchema(props.srvs, props.ccy);
</script>

<template>
	<div class="page-marketplace">
		<h1 class="flip">
			<div class="scroll">
				<div>{{ $gettext("Find your %1", $gettext("Therapist")) }}</div>
				<div>{{ $gettext("Find your %1", $gettext("Wellness expert")) }}</div>
				<div>{{ $gettext("Find your %1", $gettext("Counselor")) }}</div>
				<div>{{ $gettext("Find your %1", $gettext("Coach")) }}</div>
			</div>
		</h1>
		<div class="intro">{{ $gettext("Find and book an appointment with a top expert to help you achieve your goals.") }}</div>
		<UiScrollX class="index">
			<a v-for="pcat in pcats" :href="`category/${pcat.pcat_id}`">
				<i class="fa-light" :class="icons[pcat.pcat_id] || 'fa-user-hair'"></i>
				<span>{{ pcat.name }}</span>
			</a>
			<a class="add" href="add">
				<i class="fa-light fa-sparkles"></i>
				<span>{{ $gettext("Add your service") }}</span>
			</a>
		</UiScrollX>
		<div class="services grid">
			<Card v-for="srv in srvs" :key="srv.srv_id" :cat-name="catNames[srv.pcat_id + '/' + srv.cat_id]" :ccy="ccy" :srv="srv"/>
		</div>
		<div class="steps grid">
			<div class="step">
				<i class="fa-solid fa-circle-1"></i>
				<h2>{{ $gettext("Find") }}</h2>
				<div>{{ $gettext("Find experienced professionals in various specialties to help you achieve your personal and professional goals.") }}</div>
			</div>
			<div class="step">
				<i class="fa-solid fa-circle-2"></i>
				<h2>{{ $gettext("Book") }}</h2>
				<div>{{ $gettext("Easily and securely schedule 1:1 video appointments with an expert at a time that suits your schedule.") }}</div>
			</div>
			<div class="step">
				<i class="fa-solid fa-circle-3"></i>
				<h2>{{ $gettext("Meet") }}</h2>
				<div>{{ $gettext("You'll meet on the Vixly secure video service (in-browser) or at the location of the professional.") }}</div>
			</div>
		</div>
	</div>
</template>
